import SystemGroupsListPage from "./group-list-page.jsx";

export default SystemGroupsListPage;
